import { word } from "@modules/core/utils/i18n"
import { ProfileLabelVisibility } from "@modules/profile/myProfile/components/profileLabelVisibility"
import { ProfileFormTabProps } from "@modules/profile/myProfile/profileFormikType"
import { FormikInput } from "@modules/ui/components/formikInput"
import { HUText } from "@modules/ui/components/huText"
import { HUStack } from "@modules/ui/components/layout"
import { nameRegExp, usernameRegExp } from "@modules/utils/regexp"
import { Units } from "@modules/utils/unitType"
import { getDisplayUnits } from "@modules/utils/unitUtils"
import dayjs from "dayjs"
import { useMemo } from "react"

export const ProfileIdentifyForm: React.FC<ProfileFormTabProps> = ({
  isFormFieldInValid,
  getFormErrorMessage,
  formik,
}) => {
  const unitOptions = useMemo(
    () =>
      Units.map((unit) => ({
        value: unit,
        label: getDisplayUnits(unit),
      })),
    [],
  )

  return (
    <div className="flex flex-grow-1 flex-column justify-content-start mt-6 gap-2 px-4">
      <HUText fontStyle="TM" className="align-self-center mb-4">
        {word("profile.form.identity.title")}
      </HUText>

      {/* Firstname input */}
      <HUStack gap={6}>
        <ProfileLabelVisibility
          label={word("profile.form.firstname.label")}
          name="firstname"
          isInvalid={isFormFieldInValid("firstname")}
          isRequiredInput
        />
        <FormikInput
          textProps={{ inputRegex: nameRegExp, className: "flex-1" }}
          getFieldProps={formik.getFieldProps}
          isInvalid={isFormFieldInValid("firstname")}
          name="firstname"
          error={getFormErrorMessage("firstname")}
        />
      </HUStack>

      {/* Last name input */}
      <HUStack gap={6}>
        <ProfileLabelVisibility
          label={word("profile.form.lastname.label")}
          name="lastname"
          isInvalid={isFormFieldInValid("lastname")}
          isRequiredInput
        />
        <FormikInput
          textProps={{ inputRegex: nameRegExp, className: "flex-1" }}
          isRequiredInput
          getFieldProps={formik.getFieldProps}
          isInvalid={isFormFieldInValid("lastname")}
          name="lastname"
          error={getFormErrorMessage("lastname")}
        />
      </HUStack>

      {/* Username input */}
      <HUStack gap={6}>
        <ProfileLabelVisibility
          label={word("profile.form.username.label")}
          name="username"
          isInvalid={isFormFieldInValid("username")}
          isRequiredInput
        />
        <FormikInput
          isRequiredInput
          textProps={{ inputRegex: usernameRegExp, className: "flex-1" }}
          getFieldProps={formik.getFieldProps}
          isInvalid={isFormFieldInValid("username")}
          name="username"
          error={getFormErrorMessage("username")}
        />
      </HUStack>

      {/* Birthdate input */}
      <HUStack gap={6}>
        <ProfileLabelVisibility
          label={word("auth.signup.form.dateOfBirth")}
          name="birthdate"
          isInvalid={isFormFieldInValid("birthdate")}
          displayVisibleToggle
          visibility={formik.getFieldProps("birthdateVisibility").value}
          isRequiredInput
          onToggleVisibility={() =>
            formik.setFieldValue("birthdateVisibility", !formik.getFieldProps("birthdateVisibility").value)
          }
        />
        <FormikInput
          isInvalid={isFormFieldInValid("birthdate")}
          getFieldProps={formik.getFieldProps}
          name="birthdate"
          isRequiredInput
          error={getFormErrorMessage("birthdate")}
          placeHolder={word("auth.signup.form.dateOfBirth")}
          type="calendar"
          calendarProps={{
            maxDate: dayjs().toDate(),
            showIcon: true,
            className: "flex-1",
          }}
        />
      </HUStack>

      {/* Unit input */}
      <HUStack gap={6}>
        <ProfileLabelVisibility
          label={word("profile.unit.options.title")}
          name="unit"
          isInvalid={isFormFieldInValid("unit")}
          isRequiredInput
        />
        <FormikInput
          getFieldProps={formik.getFieldProps}
          isInvalid={false}
          name="unit"
          type="dropdown"
          dropdownProps={{
            options: unitOptions,
            value: formik.values.unit,
            className: "flex-1",
          }}
          setFieldValue={formik.setFieldValue}
        />
      </HUStack>
    </div>
  )
}
